"use client";

import React from "react";
import { Briefcase, Building2, Sparkles } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicesData = [{
  id: "01",
  title: "इंजन मरम्मत",
  description: "100 वर्षों के अनुभव के साथ, हमारे विशेषज्ञ मैकेनिक आपके इंजन की जटिल समस्याओं का सटीक निदान और समाधान करते हैं।",
  icon: Briefcase
}, {
  id: "02",
  title: "ब्रेक और टायर",
  description: "अल्बानी की सड़कों पर आपकी सुरक्षा हमारी प्राथमिकता है। हम प्रीमियम टायर और विश्वसनीय ब्रेक सेवाएं प्रदान करते हैं।",
  icon: Building2
}, {
  id: "03",
  title: "विद्युत निदान",
  description: "आधुनिक तकनीक और पारंपरिक कौशल का मेल, हम आपकी कार की वायरिंग और सेंसर की समस्याओं को जड़ से खत्म करते हैं।",
  icon: Sparkles
}];
export default function TailoredDigitalSolutions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}